import React, { useCallback } from 'react'
import { Badge, BadgeProps, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { OverlayInjectedProps } from 'react-bootstrap/Overlay'
import { uniqueId } from 'lodash'

import { OfferType } from '@monorepo/interfaces'

type QualityInfoProps = BadgeProps & {
  item: OfferType
}

export const QualityInfo: React.FC<QualityInfoProps> = ({ item, ...props }) => {
  const renderTooltip = useCallback(
    (props: OverlayInjectedProps) => (
      <Tooltip id={uniqueId('tooltip-')} {...props}>
        {item.quality?.description}
      </Tooltip>
    ),
    [item.quality]
  )

  const isShow = Boolean(item.quality?.id)

  return isShow ? (
    <OverlayTrigger placement="auto" overlay={renderTooltip}>
      <Badge {...props}>{item.quality?.name}</Badge>
    </OverlayTrigger>
  ) : null
}
